"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__Text = void 0;
const __1 = require("..");
class __Text extends __1.EL {
    tag = "__Text";
    get isControl() { return true; }
    children;
    constructor(text, range = null) {
        super("__Text", {}, [], range);
        this.children = [text];
    }
}
exports.__Text = __Text;
//# sourceMappingURL=text.js.map